var messages = {
  moveAll: '移动全部',
  item: '项',
  items: '项'
};
export default messages;